function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "seg-history_svg__a",
  d: "M503 1732a9 9 0 00-9 9h-3l4 3.99 4-3.99h-3c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 00503 1750a9 9 0 000-18zm-1 5v5l4.25 2.52.77-1.28-3.52-2.09V1737H502z"
}));
var _ref2 = /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  fillRule: "nonzero",
  xlinkHref: "#seg-history_svg__a",
  transform: "translate(-491 -1732)"
});
function SvgSegHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 18,
    viewBox: "0 0 21 18"
  }, props), _ref, _ref2);
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='21' height='18' viewBox='0 0 21 18'%3e %3cdefs%3e %3cpath id='prefix__a' d='M503 1732c-4.97 0-9 4.03-9 9h-3l4 3.99 4-3.99h-3c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42c1.63 1.63 3.87 2.64 6.36 2.64 4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.25 2.52.77-1.28-3.52-2.09V1737H502z'/%3e %3c/defs%3e %3cg fill='none' fill-rule='evenodd' transform='translate(-491 -1732)'%3e %3cuse fill='%23FFF' fill-rule='nonzero' xlink:href='%23prefix__a'/%3e %3c/g%3e %3c/svg%3e";
export { SvgSegHistory as ReactComponent };